"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputDateRangeBehavior = void 0;
var bc_calendar_behavior_1 = require("../bc-calendar/bc-calendar-behavior");
var bc_date_constants_1 = require("../bc-calendar/bc-date-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var bc_abstract_dropdown_constants_1 = require("../bc-dropdown/bc-abstract-dropdown-constants");
var bc_abstract_dropdown_behavior_1 = require("../bc-dropdown/bc-abstract-dropdown-behavior");
var BcInputDateRangeBehavior = (function (_super) {
    __extends(BcInputDateRangeBehavior, _super);
    function BcInputDateRangeBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BcInputDateRangeBehavior.setUpAll = function () {
        var inputDateElements = Array.from(document.querySelectorAll(".".concat(bc_date_constants_1.BcDateConstants.RANGE_MOLECULE_CLASSES)));
        var elements = [];
        for (var i = 0; i < inputDateElements.length; i++) {
            var element = inputDateElements[i];
            var inputDateElement = new BcInputDateRangeBehavior();
            inputDateElement.setElement(element);
            inputDateElement.setUp();
            elements.push(inputDateElement);
        }
        return elements;
    };
    BcInputDateRangeBehavior.prototype._setUp = function () {
        this.dropDownId = (0, helpers_1.getId)(BcInputDateRangeBehavior);
        this.inputDate = this.mySelf.querySelectorAll('input')[0];
        this.inputDate.style.cursor = common_constants_1.BcCommonConstants.CURSOR_POINTER;
        this.wrapperCalendar = document.createElement('div');
        this.wrapperCalendar.setAttribute('id', this.dropDownId);
        this.wrapperCalendar.classList.add(bc_abstract_dropdown_constants_1._DROPDOWN_CONTENT_CLASS);
        this.inputDateTwo = this.mySelf.querySelectorAll('input')[1];
        this.inputDateTwo.style.cursor = common_constants_1.BcCommonConstants.CURSOR_POINTER;
        var fastButtons = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.FAST_BUTTONS);
        var rangesText = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.RANGES_TEXT);
        var calendar = document.createElement('div');
        calendar.setAttribute('type', 'range');
        calendar.setAttribute(bc_date_constants_1.BcDateConstants.RANGES, fastButtons);
        calendar.setAttribute(bc_date_constants_1.BcDateConstants.RANGES_TEXT, rangesText);
        calendar.classList.add(bc_date_constants_1.BcDateConstants.CALENDAR_CLASS);
        calendar.setAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_HOLIDAY, this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_HOLIDAY));
        this.wrapperCalendar.appendChild(calendar);
        this.calendarElement = calendar;
        this.mySelf.appendChild(this.wrapperCalendar);
        var calendarBehavior = new bc_calendar_behavior_1.BcCalendarBehavior();
        this.setupMinAndMaxDate();
        calendarBehavior.setElement(this.calendarElement);
        calendarBehavior.setUp();
        this.calendarBehavior = calendarBehavior;
        this.configDropDown();
        this.addListeners();
    };
    BcInputDateRangeBehavior.prototype.configDropDown = function () {
        var toogle = document.createElement('div');
        toogle.setAttribute('aria-controls', this.dropDownId);
        toogle.classList.add(bc_abstract_dropdown_constants_1._DROPDOWN_TOGGLE_CLASS);
        toogle.style.display = common_constants_1.BcCommonConstants.NONE;
        this.mySelf.appendChild(toogle);
        this.mySelf.classList.add(bc_abstract_dropdown_constants_1._DROPDOWN_CLASS);
        var dropDowConfig = {
            toggleEvents: ['click', 'focus'],
            extraToggles: [
                {
                    node: this.inputDate,
                    events: ['focus']
                },
                {
                    node: this.inputDateTwo,
                    events: ['focus']
                }
            ],
            static: true,
            isPopUp: false,
            isDisabled: false,
            parentWidth: true,
            contentAutoWidth: true,
            maxHeightContent: this.maxHeightContent
        };
        this.setDropdownContentPosition();
        this.setConfig(dropDowConfig);
        _super.prototype._setUp.call(this);
    };
    BcInputDateRangeBehavior.prototype.addListeners = function () {
        var _this = this;
        this.calendarElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_RANGE, function (e) {
            return _this.setInputDateValues(e);
        });
        this.calendarElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CANCEL, function (e) {
            _this.closeDropdown();
        });
        this.inputDate.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
            _this.handleClick(e);
        });
        this.inputDateTwo.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
            _this.handleClick(e);
        });
        this.mySelf.querySelectorAll('em').forEach(function (em) {
            if (!em.classList.contains(bc_date_constants_1.BcDateConstants.CANCEL_CLASS)) {
                em.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return _this.openDrowndown(); }, false);
                em.style.cursor = common_constants_1.BcCommonConstants.CURSOR_POINTER;
            }
        });
    };
    BcInputDateRangeBehavior.prototype.handleClick = function (e) {
        e.preventDefault();
        this.toggleDropdown();
    };
    BcInputDateRangeBehavior.prototype.setInputDateValues = function (e) {
        this.inputDate.value = e.detail[0].toISOString().substring(0, bc_date_constants_1.SIZE_DATE_STR);
        this.inputDateTwo.value = e.detail[1].toISOString().substring(0, bc_date_constants_1.SIZE_DATE_STR);
        this.toggleDropdown();
        this.emitEvent();
    };
    BcInputDateRangeBehavior.prototype.emitEvent = function () {
        var value = {
            initialDate: this.inputDate.value,
            toDate: this.inputDateTwo.value,
        };
        this.inputDateValue = this.inputDate.value;
        this.inputDateTwoValue = this.inputDateTwo.value;
        if (this.output) {
            this.output(value);
        }
    };
    BcInputDateRangeBehavior.prototype.setValues = function (value, valueTwo) {
        if (value && valueTwo) {
            this.inputDate.value = value;
            this.inputDateTwo.value = valueTwo;
            this.emitEvent();
        }
    };
    BcInputDateRangeBehavior.prototype.setDisabled = function (isDisabled) {
        this.inputDate.disabled = isDisabled;
        this.inputDateTwo.disabled = isDisabled;
    };
    BcInputDateRangeBehavior.prototype.setupMinAndMaxDate = function () {
        var min = this.mySelf.getAttribute("min");
        var max = this.mySelf.getAttribute("max");
        if (min) {
            this.calendarElement.setAttribute("min", min);
        }
        if (max) {
            this.calendarElement.setAttribute("max", max);
        }
    };
    return BcInputDateRangeBehavior;
}(bc_abstract_dropdown_behavior_1.BcAbstractDropdownBehavior));
exports.BcInputDateRangeBehavior = BcInputDateRangeBehavior;
